
import React from 'react';
import ClassAssembly8A  from 'views/ClassAssembly8A';

const ClassAssembly5EPage = () => {
    return <ClassAssembly8A />;
  };
  
  export default ClassAssembly5EPage;
